// =============================================================================
// Agent Settings (per-user, per-agent configuration)
// =============================================================================
/** Valid provider modes — single source of truth for validation. */
export const VALID_AGENT_PROVIDER_MODES = [
    'sam',
    'user-api-key',
    'oauth',
];
/** Provider metadata registry — used by both UI and validation */
export const OPENCODE_PROVIDERS = {
    platform: {
        label: 'SAM Platform (Workers AI)',
        modelPlaceholder: 'e.g. @cf/qwen/qwen3-30b-a3b-fp8',
        requiresBaseUrl: false,
        requiresApiKey: false,
        keyLabel: '',
        keyHelpText: "Using SAM's platform AI — daily limit applies",
    },
    scaleway: {
        label: 'Scaleway',
        modelPlaceholder: 'e.g. scaleway/qwen3-coder-30b-a3b-instruct',
        requiresBaseUrl: false,
        requiresApiKey: true,
        keyLabel: 'Scaleway Secret Key',
        keyHelpText: 'Create a Scaleway API key with GenerativeApisModelAccess permission',
    },
    'opencode-managed': {
        label: 'OpenCode Managed',
        modelPlaceholder: 'e.g. opencode-zen/claude-sonnet-4-5 or opencode-go/glm-5',
        requiresBaseUrl: false,
        requiresApiKey: true,
        keyLabel: 'OpenCode API Key',
        keyHelpText: 'Enter your opencode.ai API key for managed Zen and Go models',
    },
    'google-vertex': {
        label: 'Google Vertex',
        modelPlaceholder: 'e.g. gemini-2.5-pro',
        requiresBaseUrl: false,
        requiresApiKey: true,
        keyLabel: 'Google Cloud API Key',
        keyHelpText: 'Enter your Google Cloud API key for Vertex AI',
    },
    'openai-compatible': {
        label: 'OpenAI Compatible',
        modelPlaceholder: 'e.g. your-model-name',
        requiresBaseUrl: true,
        requiresApiKey: true,
        keyLabel: 'API Key',
        keyHelpText: 'Enter your API key for the OpenAI-compatible endpoint',
    },
    anthropic: {
        label: 'Anthropic',
        modelPlaceholder: 'e.g. claude-sonnet-4-5-20250514',
        requiresBaseUrl: false,
        requiresApiKey: true,
        keyLabel: 'Anthropic API Key',
        keyHelpText: 'Enter your Anthropic API key',
    },
    custom: {
        label: 'Custom',
        modelPlaceholder: 'e.g. your-model-name',
        requiresBaseUrl: true,
        requiresApiKey: true,
        keyLabel: 'API Key',
        keyHelpText: 'Enter your API key for the custom provider',
    },
};
/** Ordered list of OpenCode provider values for dropdown rendering */
export const OPENCODE_PROVIDER_OPTIONS = [
    'platform',
    'scaleway',
    'opencode-managed',
    'google-vertex',
    'openai-compatible',
    'anthropic',
    'custom',
];
//# sourceMappingURL=agent-settings.js.map